import React from 'react';
import { Box } from '@mui/material';

import { useForecastFeedbackFormSubmissionSuccess } from 'utils/forecastFeedbackState';
import AddForm from './components/AddForm';
import Success from './components/Success';

export interface Props {
  isAccurateFeedback: boolean;
  onSubmit: () => void;
  spotId: string;
  spotName: string;
  timezone: string;
  utcOffset: number;
}

const ForecastFeedbackForms: React.FC<Props> = ({
  isAccurateFeedback,
  onSubmit,
  spotId,
  spotName,
  timezone,
  utcOffset,
}) => {
  const [submissionSuccess] = useForecastFeedbackFormSubmissionSuccess();
  return (
    <Box>
      {!submissionSuccess.status ? (
        <AddForm
          key={isAccurateFeedback ? 'accurate' : 'inaccurate'}
          isAccurateFeedback={isAccurateFeedback}
          spotId={spotId}
          spotName={spotName}
          timezone={timezone}
          utcOffset={utcOffset}
        />
      ) : (
        <Success
          buttonText="Done"
          heading="Thanks for your feedback."
          message="You're helping our data science team improve the forecasts."
          onSubmit={onSubmit}
        />
      )}
    </Box>
  );
};

export default ForecastFeedbackForms;
